// src/components/ImageManager/ImageManager.js
import React, { useRef } from 'react';
import useImageUpload from '../../hooks/useImageUpload';
import DescriptionModal from '../MainPanel/DescriptionModal';
import styles from './ImageManager.module.css';

const ImageManager = ({ 
  noteId, 
  onUploadSuccess, 
  isExpanded, 
  onToggleExpand 
}) => {
  const fileInputRef = useRef(null);
  
  const {
    uploadImage,
    handlePastedImage,
    isUploading,
    error,
    reset,
    isDescriptionModalOpen,
    handleDescriptionSave,
    cancelPendingUpload
  } = useImageUpload(noteId, onUploadSuccess);

  const handlePaste = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    await handlePastedImage(event);
  };

  const handleFileSelect = async (event) => {
    const file = event.target.files?.[0];
    if (file) {
      try {
        await uploadImage(file, 'Untitled');
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      } catch (err) {
        console.error('File upload failed:', err);
      }
    }
  };

  const handleExpandClick = (e) => {
    e.stopPropagation();
    onToggleExpand();
  };

  if (!isExpanded) {
    return (
      <div className={styles.collapsedManager} onClick={handleExpandClick}>
        
      </div>
    );
  }

  return (
    <div className={styles.imageManager}>
      <div className={styles.header} onClick={handleExpandClick}>
        <span>Image Upload</span>
      </div>
      
      <div className={styles.content} onClick={e => e.stopPropagation()}>
        <textarea
          className={styles.pasteArea}
          placeholder="Paste your image here"
          onPaste={handlePaste}
        />

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          className={styles.fileInput}
          onChange={handleFileSelect}
        />

        {error && (
          <div className={styles.error}>
            {error}
            <button onClick={reset} className={styles.dismissError}>×</button>
          </div>
        )}

        {isUploading && (
          <div className={styles.uploadingIndicator}>
            Uploading...
          </div>
        )}

        <DescriptionModal
          isOpen={isDescriptionModalOpen}
          onClose={cancelPendingUpload}
          onSave={handleDescriptionSave}
          defaultDescription="Untitled"
        />
      </div>
    </div>
  );
};

export default ImageManager;